"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleLoginButton = GoogleLoginButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_google_login_1 = require("react-google-login");
const react_intl_1 = require("react-intl");
const icons_1 = require("@ant-design/icons");
const elements_1 = require("@src/components/elements");
const axios_1 = require("@src/api/clients/axios");
const auth_1 = require("@src/types/auth");
const socket_context_1 = require("@src/context/socket-context");
const types_1 = require("@src/types");
const styled_components_1 = __importDefault(require("styled-components"));
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const StyledButton = (0, styled_components_1.default)(elements_1.Button) `
	border-radius: 1rem;
`;
function GoogleLoginButton({ type, shouldStayOnPage, onLoginSuccess }) {
    const history = (0, react_router_dom_1.useHistory)();
    const socket = (0, socket_context_1.useSocket)();
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const onSuccessfulLogin = react_1.default.useCallback(async (response) => {
        const { profileObj } = response;
        const account = await axios_1.client.post('/0/auth/google', {
            ...profileObj,
        });
        socket.emit(types_1.SocketEvents.ACCOUNT_AUTHENTICATED, account.data);
        SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
        if (onLoginSuccess) {
            onLoginSuccess(account.data);
        }
        if (shouldStayOnPage) {
            return;
        }
        if (account.data.account_type_id === types_1.AccountType.candidate) {
            // @ts-ignore
            history.pushLocalized('/ucet');
        }
        else {
            // @ts-ignore
            history.pushLocalized('/admin');
        }
    }, [shouldStayOnPage]);
    const { signIn } = (0, react_google_login_1.useGoogleLogin)({
        onSuccess: (res) => {
            onSuccessfulLogin(res);
        },
        clientId: '556754196203-lq3ahq4rbo5volp6arr53luoqtfo7ju6.apps.googleusercontent.com',
        fetchBasicProfile: true,
        onFailure: err => {
            console.error(err);
        },
    });
    return ((0, jsx_runtime_1.jsxs)(StyledButton, { className: "p-s m-t-s m-b-s flex-row align-center justify-start", size: "middle", type: "default", onClick: signIn, children: [(0, jsx_runtime_1.jsx)(icons_1.GoogleOutlined, { className: "m-r-m" }), type === auth_1.OAuthType.registration && ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "login.signup_with_google", defaultMessage: "Registrova\u0165 cez Google" })), type === auth_1.OAuthType.login && ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "login.login_with_google", defaultMessage: "Prihl\u00E1si\u0165 cez Google" }))] }));
}
